module.exports = ".user_btn.profile_label {\n    width: auto !important;\n}\n"